import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    notPlayable: {
        id: "planCard.notPlayable",
    },
    back: {
        id: "general.back",
    },
    loading: {
        id: "general.loading",
    },
    cantPlay: {
        id: "plan.cantPlay",
    },
    notFound: {
        id: "error.404.title",
    },
    displayTitle: {
        id: "display.title",
    },
    displayTask: {
        id: "display.task",
    },
    displaySimple: {
        id: "display.simple",
    },
    displaySimpleDescription: {
        id: "display.simple.description",
    },
    displayChoose: {
        id: "display.choose",
    },
    displayPlayful: {
        id: "display.playful",
    },
    displayPlayfulDescription: {
        id: "display.playful.description",
    },
    displayInfo: {
        id: "display.info",
    },
});

export default messages;
